import Vue from 'vue';
import Vuex from 'vuex';
// import login from './modules/login';
// import getters from './getters';
// import { asyncRouterMap, constantRouterMap } from '../router'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    smsBalanceSize: null,
    balanceSizeWarn: null,
    loginInfo: '',
  },
  mutations : {
    changeLogin(state,status){
      state.isLogin = status;
    }
  },
  actions: {
    loginAction({commit}){
      debugger
        commit('changeLogin',1);
    }
  }
  
});


export default store


// WEBPACK FOOTER //
// ./src/store/index.js